import { downloadData } from "aws-amplify/storage";
export const getS3UrlBasedData = {
  methods: {
    // async getS3UrlBasecDataMethod() {
    //   const orgDetails = this.$store.getters.get_current_user_details;
    //   console.log("ORG_DETAILS", orgDetails);
    //   try {
    //     const downloadResult = await downloadData({
    //       path: `${orgDetails.organization_details.productfleet_s3_key}`,
    //     }).result;
    //     const blob = await downloadResult.body.text();
    //     const parsedData = JSON.parse(blob);
    //     // console.log("PRODUCT_FLEET_DATA", parsedData);
    //     return parsedData;
    //   } catch (error) {
    //     console.error("Error_S3", error);
    //   }
    // },
    async getS3UrlBasecDataMethod() {
      const orgDetails = this.$store.getters.get_current_user_details;
      try {
        const downloadResult = await downloadData({
          path: orgDetails.organization_details.productfleet_s3_key,
          options: {
            cacheControl: "no-cache",
          },
        }).result;
        const text = await downloadResult.body.text();
        return JSON.parse(text);
      } catch (error) {
        console.error("Error_S3", error);
        throw error;
      }
    },
  },
};
